module.exports = "/_next/static/images/EnsureCustomerData-cf385efbd0ef4182a00d01e1b6d811ef.webp";